import '../customer_side/index.js'
import '../customer_side/index.scss'

// Vite emits <script type="module">, which defers execution past
// DOMContentLoaded. Turbolinks may still fire its own initial
// `turbolinks:load` later (via internal scheduling), so we listen for it
// once: if it fires within a short window, do nothing; otherwise
// dispatch it manually so legacy `$(document).on('turbolinks:load', ...)`
// handlers in customer_side scripts (configurator JS, etc.) wake up.
;(() => {
  if (document.readyState === 'loading') return
  let nativeFired = false
  const markFired = () => { nativeFired = true }
  document.addEventListener('turbolinks:load', markFired, { once: true })
  setTimeout(() => {
    if (!nativeFired) {
      document.removeEventListener('turbolinks:load', markFired)
      document.dispatchEvent(new Event('turbolinks:load'))
    }
  }, 50)
})()
